import { render, staticRenderFns } from "./DailyStatistic.vue?vue&type=template&id=0c988280&scoped=true&"
import script from "./DailyStatistic.vue?vue&type=script&lang=js&"
export * from "./DailyStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DailyStatistic.vue?vue&type=style&index=0&id=0c988280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c988280",
  null
  
)

export default component.exports